import { render, staticRenderFns } from "./NewRequest.vue?vue&type=template&id=02227f28"
import script from "./NewRequest.vue?vue&type=script&lang=js"
export * from "./NewRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports